import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {OrdersDialogService} from "../../../orders/services/order-dialogs-service.service";
import {OrderRequestsService} from "../../../orders/services/order-requests.service";
import {OrdersService} from "../../../orders/services/orders-service.service";
import {DeliveriesAlertsService} from "../../../deliveries/services/deliveries-alerts.service";
import {DeliveriesService} from "../../../deliveries/services/deliveries-service.service";
import {BillingAccountsRequests} from "../../../billing-accounts/services/billing-accounts-requests.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {PrinterService} from "../../../commons/services/printer-service.service";
import {PricePlanBundleRequestsService} from "../../../price-plan/services/price-plan-bundle-requests.service";
import {AccountModel} from "../../../account/angular/models/account.model";
import {TaskModel} from "../../../tasks/models/task.model";
import {PackageConfigurationService} from "../../../site-preferences/services/package-configuration-service.service";
import {ServicesViewsStateType} from "../../../deliveries/types/services-views-state.type";
import {ViewSettingsHolderType, ViewSettingsModel, ViewSettingsType} from "../../../commons/models/view-settings.model";
import {ViewSettingsService} from "../../../commons/services/view-settings-service.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class pointOfSaleCreateDeliveryCtrl implements IController {

  account: AccountModel;

  private order: any;

  private loading: any;
  private viewType: any;
  private creatingOrder: boolean;
  private favouriteAccountName: any;
  private billingAccount: any;
  private pricePlanBundle: any;
  private textError: any;
  private taskColorByPurpose: any;
  private vehicleTypes: any;
  private identificationOptions: any;
  private openSections: any;

  /////////////Quote//////////////
  private selectedDate: any;
  private availableDays: any;
  private quotes: any;
  private selectedQuote: any;
  private packageSizes: any;
  private defaultItemSize: any;
  private addressZoneId: string;

  /////////////Price//////////////
  private orderPrice: any;
  private paymentMethod: any;
  private paymentMethods: any;

  public viewFormSettings: ViewSettingsModel;
  public useLegacyServiceTime: boolean;

  /* @ngInject */
  constructor(private ordersService: OrdersService, private $log, private $state, private orderRequestsService: OrderRequestsService, private deliveriesAlertsService: DeliveriesAlertsService,
              private commonsAlertsService: CommonsAlertsService, private $q: IQService, private tasksConstants, private $filter, private bringozLoaderService: BringozLoaderService,
              private printerService: PrinterService, private moment, private billingAccountsRequests: BillingAccountsRequests,
              private pricePlanBundleRequestsService: PricePlanBundleRequestsService, private viewSettingsService: ViewSettingsService, private splitService: SplitService,
              private ordersDialogService: OrdersDialogService, private deliveriesService: DeliveriesService, private packageConfigurationService: PackageConfigurationService) {
  }

  $onInit() {
    this.loading = false;
    this.useLegacyServiceTime = this.splitService.getUseLegacyServiceTime();
    this.viewType = 'placeholder'; // placeholder/load/order
    this.creatingOrder = false;
    this.billingAccount = undefined;
    this.pricePlanBundle = undefined;
    this.textError = undefined; // In case of error while creating order;
    this.taskColorByPurpose = this.tasksConstants.typesToColor;
    this.quotes = [];
    this.addressZoneId = undefined;
    this.order = {};

    this.vehicleTypes = [];
    this.identificationOptions = [];
    this.openSections = {
      Pickup: false,
      Dropoff: true,
      details: true,
      timeWindow: false
    };

    this.orderPrice = undefined;
    this.paymentMethod = undefined;
    this.paymentMethods = [];

    // Init Default Account
    if (this.account) {
      this.favouriteAccountName = _.get(this.account, 'name');
      this._initAccount(this.account);
    }

    this._initViewSettings();
  }


  // ******************************
  //        Public methods
  // ******************************

  onPackageChange(packageItem, index) {
    _.set(packageItem, 'size', packageItem.type);
    _.unset(packageItem, 'type');

    const itemsCopy = angular.copy(this.order.serviceList[0].packageList[0].items);

    itemsCopy[index] = packageItem;
    this.order.serviceList[0].packageList[0].items = itemsCopy;

  }

  onSelectAccount(account: AccountModel) {
    if (account) {
      this.account = account;
      this._initAccount(account);
    }
    // Reset Flow
    else {
      this.account = undefined;
      this.viewType = 'placeholder';
      this.openSections = {
        Pickup: false,
        Dropoff: true,
        details: true,
        timeWindow: false
      };
    }
  }

  onIdentificationsChange(identifications, taskRef) {
    taskRef.taskSpec.identifications = identifications
  }

  onQuoteChange(quote) {
    this._assignQuote(quote);
  }

  setQuotesByDate(date) {
    var from = this.moment(date).startOf('day').valueOf();
    var to = this.moment(date).endOf('day').valueOf();

    this._loadQuotes(this.order.pricePlanType, from, to);

  }

  onAddressChange(address) {
    if (!_.isEmpty(address)) {
      var from = this.moment(this.selectedDate).startOf('day').valueOf();
      var to = this.moment(this.selectedDate).endOf('day').valueOf();

      this._loadQuotes(this.order.pricePlanType, from, to);
    }
  }

  onReset(form) {
    this._resetFlow();
    form.$setPristine();
    form.$setUntouched();
    this.commonsAlertsService.formResetSuccess();
  }

  onSubmit(form, event) {

    form.Pickup.$setSubmitted();
    form.Dropoff.$setSubmitted();

    if (form.$valid) {

      this.loading = true;
      this.bringozLoaderService.on();
      this._ConfirmOrder(event)
        .then(() => {
          if (this.order.serviceList[0].packageList[0]?.items?.length) {
            this.order.serviceList[0].packed = true;
          }
          return this.orderRequestsService.placeOrder(this.order, this.order.accountId);
        })
        .then((createdOrder) => {
          var printingConfig = this.printerService.getPrintingConfig();
          var delivery = createdOrder.serviceList[0];

          this.deliveriesAlertsService.createDeliverySuccess(delivery);
          this.loading = false;
          this.bringozLoaderService.off();

          if (printingConfig.enabled) {
            this.printerService.printDelivery(delivery);
            return this.ordersDialogService.printingDialog(event, delivery);
          } else {
            return this.$q.when()
          }
        })
        .then(() => {
          this._resetFlow();

          form.$setPristine();
          form.$setUntouched();
        })
        .catch((error) => {
          if (error) {
            if (error.code === 400306) {
              this.deliveriesAlertsService.invalidDeliveryDayError();
            } else {
              this.commonsAlertsService.somethingWentWrongError();
            }
            this.$log.error('createOrderFlowError', error);
          } else {
            this.$log.info('Dialog Closed');
          }
        })
        .finally(() => {
          if (this.loading) {
            this.loading = false;
            this.bringozLoaderService.off();
          }
        });
    } else {
      this.commonsAlertsService.formInvalidInfo();
    }

  }

  // ******************************
  //        Private methods
  // ******************************

  _ConfirmOrder(event) {
    return this.orderRequestsService.getOrderPrice(this.order, this.order.accountId)
      .then((orderPrice) => { // Confirm Price
        // ctrl.order.pmid = ctrl.billingAccount.defaultPaymentMethod;
        this.order.serviceList[0].billing = orderPrice.serviceBillings[0];
        return this.ordersDialogService.confirmOrderSummary(event, orderPrice);
      })
      .then((paymentMethod) => { // Place Order
        this.order.pmid = paymentMethod;
        return this.$q.when();
      });
  }

  _initAccount(account) {
    if (account.billingAccountId) {
      this.viewType = 'load';
      // return $billingAccounts(account.billingAccountId).$asyncValue()
      return this.billingAccountsRequests.getBillingAccount(account.billingAccountId)
        .then((billingAccount) => {
          this.billingAccount = billingAccount;
          return this.pricePlanBundleRequestsService.getPricePlanBundleByAccountId(account.id);
        })
        .then((pricePlanBundle) => {
          this.pricePlanBundle = pricePlanBundle;

          this._initOrder(this.account, pricePlanBundle);
          this._loadOrderSettings(this.order.pricePlanType);

          // If account did not change then init order view.
          if (this.viewType === 'load') {
            this.viewType = 'order';
          }
        })
        .catch((error) => {
          this.commonsAlertsService.somethingWentWrongError();
          this.$log.info('Failed to init account @deliveriesDialogService@createSimple', error);
        })
    } else {
      this.$log.error('Account has no billingAccountId!');
    }
  }

  _initOrder(account, pricePlanBundle) {
    this.order = this.ordersService.getEmptyDeliveryOrder(account, undefined, pricePlanBundle);
    this.order.serviceList[0].urgency = 'Other';
    this.order.serviceList[0].packageList[0].items = [];
  }

  _getServices(order) {
    var services = [{
      serviceType: order.serviceList[0].serviceType,
      tasks: []
    }];
    order.serviceList[0].taskList.forEach((task: TaskModel) => {
      services[0].tasks.push({
        purpose: task.taskSpec.purpose,
        address: task.taskSpec.address
      });
    });
    return services;
  }

  _resetFlow() {
    this.openSections = {
      Pickup: false,
      Dropoff: true,
      details: true,
      timeWindow: false
    };

    const selectedQuote = _.get(this.quotes, '[0]');

    this._initOrder(this.account, this.pricePlanBundle);
    this._assignQuote(selectedQuote);
  }

  _loadOrderSettings(selectedPricePlanType) {

    // const quoteTypes = ['Urgency','TimeSlot','DynamicTimeSlot','FreeStyle','PerTask'];

    this.ordersService.getOrderSettings(this.order.accountId, this.order.serviceList[0].serviceType, selectedPricePlanType)
      .then((orderSettings) => {
        const serviceRef = orderSettings;

        this.availableDays = _.get(serviceRef, 'availableDays', []);
        this.packageSizes = serviceRef.itemSizeList;
        this.vehicleTypes = _.get(serviceRef, 'vehicleList', []);
        this.defaultItemSize = serviceRef.defaultItemSize;
        this.order.serviceList[0].vehicleType = _.get(serviceRef, 'defaultVehicle');

        if (!this.order.serviceList[0].packageList[0].items.length) {
          var defaultItemSizeItem = _.find(this.packageSizes, (p) => {
            return p.itemSize === serviceRef.defaultItemSize;
          });

          if (defaultItemSizeItem) {
            this.order.serviceList[0].packageList[0].items.push(
              {
                count: 1,
                barcode: null,
                size: defaultItemSizeItem.itemSize || 'NoPackage',
                labels: defaultItemSizeItem.labels || [],
                dimensions: defaultItemSizeItem.dimensions || {},
                weight: defaultItemSizeItem.weight
              }
            )
          }
        }

        this.identificationOptions = this.ordersService.buildIdentificationOptions(
          serviceRef.dropoffPodSettings,
          serviceRef.dropoffPodFillRequiredSettings
        );
        const defaultIdentification = this.ordersService.buildDefaultIdentifications(
          serviceRef.dropoffPodSettings,
          serviceRef.dropoffPodFillRequiredSettings
        );

        _.forEach(this.order.serviceList[0].taskList, (t) => {

            if (t.taskSpec.purpose === 'Pickup') {
              if (this.useLegacyServiceTime) {
                t.taskSpec.serviceTime = _.get(serviceRef, 'serviceTimeSettings.pickupDetailedServiceTime.generatedTotalTime', 0);
              } else {
                t.taskSpec.detailedServiceTime = _.get(serviceRef, 'serviceTimeSettings.pickupDetailedServiceTime', {})
              }
            }

            if (t.taskSpec.purpose === 'Dropoff') {
              if (this.useLegacyServiceTime) {
                t.taskSpec.serviceTime = _.get(serviceRef, 'serviceTimeSettings.dropoffDetailedServiceTime.generatedTotalTime', 0);
              } else {
                t.taskSpec.detailedServiceTime = _.get(serviceRef, 'serviceTimeSettings.dropoffDetailedServiceTime', {})
              }
            }

            const purpose = t.taskSpec.purpose;
            if (purpose === 'Dropoff') {
              this.onIdentificationsChange(defaultIdentification, t);
            }
          }
        )
        ;
      })
  }

  _loadQuotes(selectedPricePlanType, from, to) {
    const services = this._getServices(this.order);

    this.loading = true;
    this.ordersService.getOrderQuote(services, this.order.accountId, selectedPricePlanType, from, to)
      .then((service) => {
        this.quotes = service.quotes;
        this.addressZoneId = _.get(service, 'destinationZoneId');

        // if (ctrl.quotes.length) {
        //   _assignQuote(ctrl.quotes[0]);
        // } else {
        //   ctrl.viewType = 'error';
        //   ctrl.textError = 'The current settings in this account disable creating an order using the New Order shortcut.';
        //   ctrl.noFreeStyleError = 'Please enable Freestyle Time Window or use the Advanced button below'
        // }

        this._assignQuote(_.get(this.quotes, '[0]'));
      })
      .catch((error) => {
        this.$log.error('Failed to get quotes', error)
      })
      .finally(() => {
        this.loading = false;
      })
  }

  _assignQuote(quote) {
    this.selectedQuote = angular.copy(quote);

    if (_.get(quote, 'type') === 'PerTask') {
      quote = this.quotes[0];
    }

    this.selectedDate = quote ? new Date(_.get(quote, 'startTime')) : undefined;
    this.deliveriesService.updateDeliveryQuote(this.order.serviceList[0], quote);
  }


  private

  _initViewSettings() {
    this.viewSettingsService.getBySite(ServicesViewsStateType.DELIVERIES_FORM_STATE, ViewSettingsType.Form)
      .then((viewSettings: ViewSettingsModel[]) => {
        const userViewFormSettings = viewSettings.find(v => v.holderType === ViewSettingsHolderType.Site);
        if (userViewFormSettings) {
          this.viewFormSettings = userViewFormSettings
        } else {
          this.viewFormSettings = viewSettings.find(v => v.holderType === ViewSettingsHolderType.Site);
        }
      })
  }

}

angular
  .module(
    'bringoz.admin.point-of-sale'
  )
  .component(
    'pointOfSaleCreateDelivery'
    , {
      bindings: {
        account: '<'
      }
      ,
      template: require
      (
        './point-of-sale-create-delivery.html'
      ).default
      ,
      controller: pointOfSaleCreateDeliveryCtrl
    }
  )
;
